import {
  API_ERROR,
  TAX,
  TAX_LIST_SUCCESSFUL,
  TAX_ADD,
  TAX_ADD_SUCCESSFUL,
  TAX_EDIT,
  TAX_EDIT_SUCCESSFUL,
  TAX_DELETE,
  TAX_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

export const getTaxs = () => {
  return {
    type: TAX,
  };
};

export const TaxListSuccessful = (Tax) => {
  return {
    type: TAX_LIST_SUCCESSFUL,
    payload: Tax,
  };
};

export const TaxAdd = (Tax, history) => {
  return {
    type: TAX_ADD,
    payload: { Tax, history },
  };
};

export const TaxAddSuccessful = (response) => {
  return {
    type: TAX_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const TaxEdit = (data) => {
  return {
    type: TAX_EDIT,
    payload: data,
  };
};

export const TaxEditSuccessful = (response) => {
  return {
    type: TAX_EDIT_SUCCESSFUL,
    payload: response,
  };
};

export const TaxDelete = (TaxId, history) => {
  return {
    type: TAX_DELETE,
    payload: { TaxId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: TAX_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
